<template>

<!-- NAVBAR -->
<div class="hero is-medium has-bg-img">
  <img :alt="img_alt" class="is-bg-img" :src="img" />
  <div class="hero-body">
    <div class="container">
      <div class="columns is-centered is-mobile">
        <div class='column is-6-fullhd is-6-widescreen is-8-desktop is-10-tablet is-10-mobile'>
          <h1 class="title is-size-2-mobile">
            {{ title }}
          </h1>
          <h2>
            <span class='byline-author'><a href="https://againwewander.com">{{ author }}</a></span> | <span class='byline-date'>{{ date }}</span>
          </h2>
        </div>
      </div>
    </div>
  </div>
</div>

</template>


<script>
export default {
  props: {
    img_alt: String,
    img: String,
    title: String,
    author: String,
    date: String
  }
}
</script>


<style scoped lang='scss'>

.has-bg-img {
  overflow: hidden;
  position: relative;
}

div.has-bg-img {
  background-color: $bg-darker;
}  

.is-bg-img {
  position: absolute;
  object-fit: cover;
  object-position: center center;

  height: 100%;
  width: 100%;


  opacity: 0.4;
  filter: brightness(200%);
  filter: blur(2px);

}

.title {
  font-size: 5rem;

  font-family: Rubik, sans-serif;
  font-weight: 700;
  color: white;

  text-decoration: underline;
  text-decoration-color: $purple;

  word-break: break-word;
  word-wrap: break-word;       /* Internet Explorer 5.5+ */
  
}

.byline-date, .byline-author {
  font-family: Rubik, sans-serif;
  font-weight: 700;
  color: $azul;
}

.byline-author a {
  color: $azul
}

</style>
